export const REGISTRATION_REQUEST_SENT = "TokenAuth/REGISTRATION_REQUEST_SENT";
export const REGISTRATION_REQUEST_SUCCEEDED = "TokenAuth/REGISTRATION_REQUEST_SUCCEEDED";
export const REGISTRATION_REQUEST_FAILED = "TokenAuth/REGISTRATION_REQUEST_FAILED";
export const VERIFY_TOKEN_REQUEST_SENT = "TokenAuth/VERIFY_TOKEN_REQUEST_SENT";
export const VERIFY_TOKEN_REQUEST_SUCCEEDED = "TokenAuth/VERIFY_TOKEN_REQUEST_SUCCEEDED";
export const VERIFY_TOKEN_REQUEST_FAILED = "TokenAuth/VERIFY_TOKEN_REQUEST_FAILED";
export const SIGNIN_REQUEST_SENT = "TokenAuth/SIGNIN_REQUEST_SENT";
export const SIGNIN_REQUEST_SUCCEEDED = "TokenAuth/SIGNIN_REQUEST_SUCCEEDED";
export const SIGNIN_REQUEST_FAILED = "TokenAuth/SIGNIN_REQUEST_FAILED";
export const SIGNOUT_REQUEST_SENT = "TokenAuth/SIGNOUT_REQUEST_SENT";
export const SIGNOUT_REQUEST_SUCCEEDED = "TokenAuth/SIGNOUT_REQUEST_SUCCEEDED";
export const SIGNOUT_REQUEST_FAILED = "TokenAuth/SIGNOUT_REQUEST_FAILED";
export const SET_HAS_VERIFICATION_BEEN_ATTEMPTED = "TokenAuth/SET_HAS_VERIFICATION_BEEN_ATTEMPTED";
export const registrationRequestSent = () => ({
  type: REGISTRATION_REQUEST_SENT,
});
export const registrationRequestSucceeded = (userAttributes) => ({
  type: REGISTRATION_REQUEST_SUCCEEDED,
  payload: {
    userAttributes,
  },
});
export const registrationRequestFailed = () => ({
  type: REGISTRATION_REQUEST_FAILED,
});
export const verifyTokenRequestSent = () => ({
  type: VERIFY_TOKEN_REQUEST_SENT,
});
export const verifyTokenRequestSucceeded = (userAttributes) => ({
  type: VERIFY_TOKEN_REQUEST_SUCCEEDED,
  payload: {
    userAttributes,
  },
});
export const verifyTokenRequestFailed = () => ({
  type: VERIFY_TOKEN_REQUEST_FAILED,
});
export const signInRequestSent = () => ({
  type: SIGNIN_REQUEST_SENT,
});
export const signInRequestSucceeded = (userAttributes) => ({
  type: SIGNIN_REQUEST_SUCCEEDED,
  payload: {
    userAttributes,
  },
});
export const signInRequestFailed = () => ({
  type: SIGNIN_REQUEST_FAILED,
});
export const signOutRequestSent = () => ({
  type: SIGNOUT_REQUEST_SENT,
});
export const signOutRequestSucceeded = () => ({
  type: SIGNOUT_REQUEST_SUCCEEDED,
});
export const signOutRequestFailed = () => ({
  type: SIGNOUT_REQUEST_FAILED,
});
export const setHasVerificationBeenAttempted = (hasVerificationBeenAttempted) => ({
  type: SET_HAS_VERIFICATION_BEEN_ATTEMPTED,
  payload: {
    hasVerificationBeenAttempted,
  },
});
